module.exports = __webpack_public_path__ + "img/Populus_tremula.febac791.jpg";